import "./Ktnl_lp.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import CONFIG from "../src/config";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function KTNL_LP() {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.ktnl;

  const [depositAmount, setDepositAmount] = useState("");
  const [noOfYears, setNoOfYears] = useState("");
  const [interestRate, setInterestRate] = useState("");
  const [compoundedMonths, setCompoundedMonths] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [enduiryformData1, setEnduiryformData1] = useState({ amount: "" });
  const [customerSupportContent, setCustomerSupportContent] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport/Customersubsupport`
        );
        if (response.data && response.data.length > 0) {
          setCustomerSupportContent(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  ////Api content 2nd part
  const [customerSupportContent2, setCustomerSupportContent2] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport2/Customersubsupport2`
        ); // Replace with your API URL
        if (response.data && response.data.length > 0) {
          // Assuming the response is an array and you want the description from the first object
          setCustomerSupportContent2(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  /////KTNL Sub content customer support Api part

  ////Api content 3rd part
  const [customerSupportContent3, setCustomerSupportContent3] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport3/Customersubsupport3`
        );
        if (response.data && response.data.length > 0) {
          setCustomerSupportContent3(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  /////KTNL Sub content customer support 4 Api part

  ////Api content 4th Api part
  const [customerSupportContent4, setCustomerSupportContent4] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport4/Customersubsupport4`
        );
        if (response.data && response.data.length > 0) {
          setCustomerSupportContent4(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  const [customerSupportContent5, setCustomerSupportContent5] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport5/Customersubsupport5`
        );
        if (response.data && response.data.length > 0) {
          setCustomerSupportContent5(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  const [customerSupportContent6, setCustomerSupportContent6] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport6/Customersubsupport6`
        );
        if (response.data && response.data.length > 0) {
          setCustomerSupportContent6(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  const [customerSupportContent7, setCustomerSupportContent7] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport7/Customersubsupport7`
        );
        if (response.data && response.data.length > 0) {
          setCustomerSupportContent7(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  const [customerSupportContent8, setCustomerSupportContent8] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLsubSupport8/Customersubsupport8`
        );
        if (response.data && response.data.length > 0) {
          setCustomerSupportContent8(response.data[0].description);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchData();
  }, []);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${CONFIG.BASE_URL}/KTNLSupport/Customersupport`
        );
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const initialFormData = {
    customername: "",
    email: "",
    contact: "",
    amount: "",
  };

  const [enduiryformData, setEnquiryFormData] = useState(initialFormData);
  // const [errors, setErrors] = useState({});
  // const [showAlert, setShowAlert] = useState(false);

  const validateForm = () => {
    let newErrors = {};

    // Name Validation (Only letters & spaces, min 3 characters)
    if (!/^[A-Za-z\s]{3,}$/.test(enduiryformData.customername)) {
      newErrors.customername =
        "Enter a valid name (min 3 letters, only alphabets).";
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const allowedEmailPattern =
      /^[\w.-]+@(gmail\.com|yahoo\.com|outlook\.com|rediffmail\.com|hotmail\.com|icloud\.com|protonmail\.com|aol\.com|cogniitec\.com)$/;

    if (!enduiryformData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!emailPattern.test(enduiryformData.email)) {
      newErrors.email = "Valid Email is required.";
    } else if (!allowedEmailPattern.test(enduiryformData.email)) {
      newErrors.email =
        "Email must be from allowed domains (e.g., user@gmail.com).";
    }

    // Contact Validation (Must start with 6,7,8,9 and be exactly 10 digits)
    if (!/^[6789]\d{9}$/.test(enduiryformData.contact)) {
      newErrors.contact =
        "Enter a valid 10-digit number starting with 6,7,8, or 9.";
    }

    // Amount Validation (Only numbers)
    if (!/^\d+$/.test(enduiryformData.amount)) {
      newErrors.amount = "Enter a valid amount (numbers only).";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateFormCalculator = () => {
    let newErrors = {};

    // Check if depositAmount is entered and valid
    if (!depositAmount) {
      newErrors.depositAmount = "Deposit amount is required.";
    } else if (!/^\d{1,9}$/.test(depositAmount)) {
      newErrors.depositAmount = "Deposit amount should be up to 9 digits only.";
    }

    // Check if noOfYears is entered and valid
    if (!noOfYears) {
      newErrors.noOfYears = "Number of years is required.";
    } else if (!/^\d{1,2}$/.test(noOfYears)) {
      newErrors.noOfYears = "Number of years should be up to 2 digits only.";
    }

    // Check if interestRate is entered and valid
    if (!interestRate) {
      newErrors.interestRate = "Interest rate is required.";
    } else if (!/^\d+(\.\d+)?$/.test(interestRate)) {
      newErrors.interestRate = "Enter a valid interest rate.";
    }

    // Check if compounded option is selected
    if (!compoundedMonths) {
      newErrors.compoundedMonths = "Compounding option is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update input value
    setEnquiryFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear the error message as the user types
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Remove error for current field
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    setShowAlert(true);

    try {
      const response = await fetch(`${CONFIG.BASE_URL}/BrAcademy/Enquiryform`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(enduiryformData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        // alert("Form submitted successfully!");

        // Reset form fields after successful submission
        setEnquiryFormData({
          customername: "",
          email: "",
          contact: "",
          amount: "",
        });

        // Hide the alert after 3 seconds
        setTimeout(() => setShowAlert(false), 3000);
      } else {
        console.error("Error:", response.statusText);
        alert("Failed to submit the form.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while submitting the form.");
    }
  };

  const calculateFD = (e) => {
    e.preventDefault();

    if (validateFormCalculator()) {
      // Perform calculation logic here
      setTotalAmount("Rs. 1000000"); // Dummy value for now
    }

    const principal = parseFloat(depositAmount);
    const rate = parseFloat(interestRate) / 100;
    const time = parseFloat(noOfYears);
    const n = compoundedMonths ? 12 / parseFloat(compoundedMonths) : 0;

    // Input validation
    if (
      isNaN(principal) ||
      principal <= 0 ||
      isNaN(rate) ||
      rate <= 0 ||
      isNaN(time) ||
      time <= 0 ||
      !compoundedMonths ||
      n <= 0
    ) {
      setTotalAmount("Invalid Input");
      return;
    }

    // Compound Interest Formula: A = P * (1 + r/n)^(n*t)
    const amount = principal * Math.pow(1 + rate / n, n * time);
    setTotalAmount(Math.round(amount)); // Round to the nearest integer
  };

  const handleClear = () => {
    setDepositAmount("");
    setNoOfYears("");
    setInterestRate("");
    setCompoundedMonths("");
    setTotalAmount("");
    setErrors({});
  };

  return (
    <div>
      <SEO {...meta} />

      <div class="body-wrapper ktnl_landingpage">
        <div class="announcement-bar">
          <div class="top">
            <div class="row col-lg-11ss align-items-center justify-content-right news_wrapper_inner">
              <div class="col-lg-7 margin_righttop  align-items-center m-auto justify-content-right">
                <div class="col-lg-12 d-lg-block ">
                  <div class="news d-flex align-items-center m-auto">
                    <h5 class="newstitle">Whats New |</h5>
                    <div class="news_wrapper">
                      <div class="marquee">
                        <p>
                          Maturity on yearly basis &nbsp;(can withdraw or renew
                          every 12 months once) &nbsp;&nbsp;&nbsp;
                        </p>
                        <p>
                          Our Fixed Deposits have a tenure of 1 to 5 year with
                          highest FD interest rates. &nbsp;&nbsp;&nbsp;
                        </p>
                      </div>
                    </div>
                    <span class="col-lg-4 article-author d-flex align-items-center">
                      <a class=" d-flex brandcolor" href="tel:0422-4379977">
                        <span class="icon callicons">
                          <img
                            src="./assets/img/slideshow/call.png"
                            width="25"
                            he
                            alt=""
                          />
                        </span>
                        +91 6380750896
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <header class="sticky-header border-btm-black header-1">
          <div class="header-bottom col-lg-11ss menusect bg-3 ">
            <div class="container">
              <div class="row  justify-content-right">
                <div class="col-lg-3 col-md-4 col-4">
                  <div class="header-logo">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.kovaitechnidhi.com/"
                      class="logo-main"
                    >
                      <img
                        src="assets/img/brandlogo.png"
                        loading="lazy"
                        alt="KTNL"
                      />
                      <div class="brand_title_wrap">
                        <h1 class="brand_title">KTNL</h1>
                        <span class="title_expant">
                          Kovai Tech Nidhi Limited
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="col-lg-9 d-lg-block d-none">
                  <nav class="site-navigation">
                    <ul class="main-menu list-unstyled justify-content-right">
                      <div class="banner_menu p-0">
                        <span className="text-white text-right d-block">
                          Reg by :{" "}
                          <a href="https://pib.gov.in/PressReleasePage.aspx?PRID=1818298">
                            MINISTRY OF CORPORATE AFFAIRS
                          </a>
                        </span>
                      </div>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <div class="search-wrapper">
              <div class="container">
                <form action="#" class="search-form d-flex align-items-center">
                  <button
                    type="submit"
                    class="search-submit bg-transparent pl-0 text-start"
                  >
                    <svg
                      class="icon icon-search"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.75 0.250183C11.8838 0.250183 15.25 3.61639 15.25 7.75018C15.25 9.54608 14.6201 11.1926 13.5625 12.4846L19.5391 18.4611L18.4609 19.5392L12.4844 13.5627C11.1924 14.6203 9.5459 15.2502 7.75 15.2502C3.61621 15.2502 0.25 11.884 0.25 7.75018C0.25 3.61639 3.61621 0.250183 7.75 0.250183ZM7.75 1.75018C4.42773 1.75018 1.75 4.42792 1.75 7.75018C1.75 11.0724 4.42773 13.7502 7.75 13.7502C11.0723 13.7502 13.75 11.0724 13.75 7.75018C13.75 4.42792 11.0723 1.75018 7.75 1.75018Z"
                        fill="black"
                      />
                    </svg>
                  </button>
                  <div class="search-input mr-4">
                    <input
                      type="text"
                      placeholder="Search your products..."
                      autocomplete="off"
                    />
                  </div>
                  <div class="search-close">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="icon icon-close"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </header>
        {/* <!-- header end --> */}

        <main id="MainContent" class="content-for-layout">
          <div class="row banner_menu_wrap col-lg-11 align-items-center m-0 justify-content-right">
            <div class="banner_wrapper p-0">
              <div class="section-banner">
                <img src="./assets/img/slideshow/banner1.jpg" alt="Banener" />
              </div>
            </div>
          </div>

          <div class="product-page mt-10">
            <div class="container">
              <div class="row">
                <div class="col-lg-7 col-md-12 col-12">
                  <div class="product-gallery">
                    <div class="product-img-large">
                      <div class="tab-list product-tab-list">
                        <nav class="nav product-tab-nav">
                          <a
                            class="product-tab-link tab-link  brandcolor_bg1 active"
                            href="#pdescription"
                            data-bs-toggle="tab"
                          >
                            Fixed Deposit
                          </a>
                          <a
                            class="product-tab-link tab-link  brandcolor_bg1  brandcolor_bg3"
                            href="#pshipping"
                            data-bs-toggle="tab"
                          >
                            Recurring Deposit
                          </a>
                          <a
                            class="product-tab-link tab-link  brandcolor_bg1"
                            href="#pstyle"
                            data-bs-toggle="tab"
                          >
                            Savings Account
                          </a>
                          <a
                            class="product-tab-link tab-link  brandcolor_bg1 "
                            href="#preview"
                            data-bs-toggle="tab"
                          >
                            Loans
                          </a>
                        </nav>
                        <div class="tableinner_caption_wrap">
                          <div class="tableinner_caption_inner">
                            <span class="tableinner_caption text-center border-rd">
                              Senior citizens at 12.5% pa
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="tab-content product-tab-content">
                        <div
                          id="pdescription"
                          class="tab-pane fade show active"
                        >
                          <div class="row">
                            <div class="col-lg-12 p-0 col-md-12 col-12">
                              <div class="desc-content">
                                <table class="servicetable mt-0 col-md-12 col-12">
                                  <tbody>
                                    <tr class="barndgradients">
                                      <th>Service</th>
                                      <th>Interest Rate</th>
                                      <th>Years</th>
                                    </tr>
                                    <tr class="barndblue">
                                      <th>RD</th>
                                      <th>9.5% pa</th>
                                      <th>1-5 years</th>
                                    </tr>
                                    <tr class="barndgradients">
                                      <th>FD</th>
                                      <th>12-12.5 pa</th>
                                      <th>1-5 years</th>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4 class="heading_18 mb-3">About Us</h4>
                                <p class="text_16 mb-4">
                                  At Kovai Tech Nidhi Limited, we understand
                                  that applying for a loan or managing your
                                  finances can be complex. That's why we're
                                  dedicated to providing clear, helpful, and
                                  timely support to all our customers. Whether
                                  you need assistance with the application
                                  process, have questions about your loan terms,
                                  or require general financial guidance, our
                                  friendly and knowledgeable team is here to
                                  help. Kovai Tech Nidhi Limited is committed to
                                  providing exceptional customer service. For
                                  assistance with your loan application, account
                                  inquiries, or any other matters, please
                                  contact us . Our dedicated team is available
                                  24 hrs to answer your questions and provide
                                  support.
                                </p>
                                <div className="succesmesg">
                                  {" "}
                                  {data.map((item) => (
                                    <div key={item.id}>
                                      <h3 class="heading_18 mb-3">
                                        {item.title}
                                      </h3>
                                      <p class="text_16 mb-4">
                                        {item.description}
                                      </p>
                                    </div>
                                  ))}
                                </div>

                                <div class="mt-3 ktnnl_tab_content_cta pb-3 col-lg-12">
                                  <button>
                                    <a
                                      href="https://www.kovaitechnidhi.com/fixed-deposit/"
                                      type="button"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-white w-12 position-relative"
                                    >
                                      Read More
                                    </a>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="pshipping" class="tab-pane fade">
                          <div class="desc-content">
                            <h4 class="heading_18 mb-3">
                              Recurring Deposit (RD)
                            </h4>
                            <p class="text_16 mb-4">
                              Recurring Deposit (RD) is a popular investment
                              option in India. It comes with an option of
                              flexibility for customers in the choice of best RD
                              schemes and tenure, accompanied by the highest RD
                              interest rates. Fixed and recurring deposits are
                              almost similar investment instruments. However,
                              you have to make fixed monthly deposits in
                              recurring deposits for good returns. RD Interest
                              Calculator enables depositors to plan their future
                              needs with greater clarity with the exact accrued
                              interest on recurring deposits.
                            </p>

                            <p class="text_16">
                              Investors can thus choose a minimum amount of RD
                              installment as a sip investment every month over
                              the term for assured wealth generation. If you do
                              not have a lump sum amount to meet short-term
                              goals, depositing a small share of your income to
                              the KTNL RD account every month serves the purpose
                              well. RD allows you to earn fixed interest on the
                              amount invested at frequent intervals until the
                              investment matures or a pre-determined term ends.
                            </p>

                            <div class="mt-3 ktnnl_tab_content_cta pb-3 col-lg-12">
                              <button>
                                <a
                                  href="https://www.kovaitechnidhi.com/recurring-deposit/"
                                  type="button"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-white w-12 position-relative"
                                >
                                  Read More
                                </a>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div id="pstyle" class="tab-pane fade">
                          <div class="desc-content">
                            <h4 class="heading_18 mb-3">Savings Account</h4>
                            <p class="text_16 mb-4">
                              A savings account allows you to do all your
                              financial transactions safely and conveniently.
                              With the power of technology and value-added
                              services, you are never far away from your
                              account. We have different types of savings
                              accounts to suit your specific needs. We can cater
                              to all your needs in this. A savings account is an
                              interest-bearing deposit account held at KTNL
                              though these accounts typically pay a modest
                              interest rate, it is a great option when it comes
                              to safety and reliability for parking your cash
                              and is available whenever you want for your needs.
                            </p>
                            <p class="text_16 mb-4">
                              You have to pay for return shipping if you want to
                              exchange your product for another size or the
                              package is returned because it has not been picked
                              up at the post office.
                            </p>

                            <div class="mt-3 ktnnl_tab_content_cta pb-3 col-lg-12">
                              <button>
                                <a
                                  href="https://www.kovaitechnidhi.com/savings-account/"
                                  type="button"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-white w-12 position-relative"
                                >
                                  Read More
                                </a>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div id="preview" class="tab-pane fade">
                          <div class="desc-content">
                            <h4 class="heading_18 mb-3">
                              Gold Loan in Kovai Tech Nidhi Limited
                            </h4>
                            <p class="text_16 mb-4">
                              GOLD is money. Everything else is credit. The name
                              itself brings images of wealth to our minds. The
                              idea of a gold loan is simple. You pledge your
                              gold ornaments and get the loan amount. The lender
                              checks the purity of the gold and determines its
                              weight, and on that basis estimates its market
                              value.
                            </p>

                            <h4 class="heading_18 mb-3">
                              Loan Against Deposit in Kovai Tech Nidhi Limited
                            </h4>
                            <p class="text_16 mb-4">
                              Loan against Deposits is an ideal tool/financial
                              product to avail funds that one can utilize with
                              flexibility for both personal and business uses.
                              KTNL enables the availability of Loan against
                              Deposits on different types of investments,
                              properties so on. We offer exclusive and
                              attractive loan to value on the property that
                              serves different financial purposes. Our online
                              interface of functioning helps in instant
                              processing and approval of loan, and initiates
                              quick disbursal.
                            </p>

                            <div class="mt-3 ktnnl_tab_content_cta pb-3 col-lg-12">
                              <button>
                                <a
                                  href="https://www.kovaitechnidhi.com/gold-loan/"
                                  type="button"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-white w-12 position-relative"
                                >
                                  Read More
                                </a>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 col-md-12 col-12">
                  <div class="product-details Rd_calculator ps-lg-4">
                    <h2 class="product-title mt-0 mb-3">WE OFFER</h2>

                    <div class="contact-item">
                      <div class="contact-icon">
                        <svg
                          width="36"
                          height="42"
                          viewBox="0 0 36 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18 0.265625L16.4141 4.09375L2.41406 37.3438L0.828125 41.0625L4.60156 39.6406L18 34.6094L31.3984 39.6406L35.1719 41.0625L33.5859 37.3438L19.5859 4.09375L18 0.265625ZM18 9.17969L28.8281 34.9375L18.6016 31.1094L18 30.8906L17.3984 31.1094L7.17188 34.9375L18 9.17969Z"
                            fill="#00234D"
                          ></path>
                        </svg>
                      </div>
                      <div class="contact-details">
                        <p class="contact-info">
                          Our Fixed Deposits have a tenure of 1 to 5 year with
                          highest FD interest rates.
                        </p>
                      </div>
                    </div>

                    <form
                      autoComplete="off"
                      className="product-form"
                      onSubmit={calculateFD}
                    >
                      <div className="buy-it-now-btn mt-2">
                        <fieldset>
                          <input
                            type="number"
                            className="mt-2"
                            placeholder="Deposit amount (Rs)"
                            value={depositAmount}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value.length <= 9) setDepositAmount(value);
                            }}
                          />
                          {errors.depositAmount && (
                            <span className="error-text">
                              {errors.depositAmount}
                            </span>
                          )}
                        </fieldset>
                        <fieldset>
                          <input
                            type="number"
                            className="mt-2"
                            placeholder="No. of years"
                            value={noOfYears}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value.length <= 2) setNoOfYears(value);
                            }}
                          />
                          {errors.noOfYears && (
                            <span className="error-text">
                              {errors.noOfYears}
                            </span>
                          )}
                        </fieldset>
                        <fieldset>
                          <input
                            type="number"
                            className="mt-2"
                            placeholder="Interest rate per year"
                            value={interestRate}
                            onChange={(e) => setInterestRate(e.target.value)}
                          />
                          {errors.interestRate && (
                            <span className="error-text">
                              {errors.interestRate}
                            </span>
                          )}
                        </fieldset>
                        <fieldset>
                          <select
                            className="select-style"
                            value={compoundedMonths}
                            onChange={(e) => {
                              console.log("Selected:", e.target.value);
                              setCompoundedMonths(e.target.value);
                            }}
                          >
                            <option value="">Select Compounded</option>
                            <option value="1">Compounded Monthly</option>
                            <option value="3">Compounded Quarterly</option>
                            <option value="6">Compounded Half Yearly</option>
                            <option value="12">Compounded Yearly</option>
                          </select>
                          {errors.compoundedMonths && (
                            <span className="error-text">
                              {errors.compoundedMonths}
                            </span>
                          )}
                        </fieldset>

                        <fieldset>
                          <input
                            type="text"
                            className="mt-2"
                            placeholder="Rs.0000000"
                            value={
                              isNaN(totalAmount)
                                ? totalAmount
                                : `Maturity Amt Rs. ${totalAmount}`
                            }
                            readOnly
                          />
                        </fieldset>
                        <button
                          type="submit"
                          className="mt-3 w-12 me-3 btn-buyit-now  position-relative "
                        >
                          Calculate
                        </button>
                        <button
                          type="button"
                          className="mt-3 w-12 button-submit btn-buyit-now "
                          onClick={handleClear}
                        >
                          Clear
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-page mt-50">
            <div class="container">
              <div class="row">
                <div class="col-lg-7 col-md-12 col-12">
                  <div class="product-gallery">
                    <div class="">
                      <div class="contact-item">
                        <div class="contact-icon">
                          <span class="icon callicons">
                            <img
                              src="./assets/img/slideshow/pulp.png"
                              width="25"
                              he=""
                              alt=""
                            />
                          </span>
                        </div>
                        <div class="contact-details">
                          <p class="contact-info">
                            <b class="brandcolor">Fixed</b> Deposit Interest
                            will be credited to your KTNL Savings Account with
                            us.
                          </p>
                          <div class="contact-details">
                            <p class="contact-info">
                              <b class="brandcolor">Fixed</b>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="contact-item">
                        <div class="contact-icon">
                          <span class="icon callicons">
                            <img
                              src="./assets/img/slideshow/pulp.png"
                              width="25"
                              he=""
                              alt=""
                            />
                          </span>
                        </div>
                        <div class="contact-details">
                          <p class="contact-info">
                            <b class="brandcolor">FD</b> Interest will be
                            credited to your other Bank Account also for which
                            you have to provide your Bank Account Proof, Either
                            passbook copy or personalised cancelled cheque leaf
                            or Authenticated bank statement containing the
                            Account Number, Name of the Bank, Branch, IFSC Code
                            etc. {customerSupportContent2}
                          </p>
                          <p class="contact-info">
                            <b class="brandcolor">FD</b>{" "}
                          </p>
                        </div>
                      </div>
                      <div class="contact-item">
                        <div class="contact-icon">
                          <span class="icon callicons">
                            <img
                              src="./assets/img/slideshow/pulp.png"
                              width="25"
                              he=""
                              alt=""
                            />
                          </span>
                        </div>
                        <div class="contact-details">
                          <p class="contact-info">
                            Your <b class="brandcolor">FD</b> Interest will be
                            credited to your prescribed savings account on the
                            same date of fixed deposit opened as per the
                            interest credit mode which you wish to avail
                            (Monthly, Quarterly, Half Yearly or Yearly){" "}
                          </p>
                          <p class="contact-info">
                            Your <b class="brandcolor">FD</b>{" "}
                          </p>
                        </div>
                      </div>
                      <div class="contact-item">
                        <div class="contact-icon">
                          <span class="icon callicons">
                            <img
                              src="./assets/img/slideshow/pulp.png"
                              width="25"
                              he=""
                              alt=""
                            />
                          </span>
                        </div>
                        <div class="contact-details">
                          <p class="contact-info">
                            At Kovai Tech Nidhi Limited, we provide Net Banking,
                            Mobile App Banking, Debit Card Facility, Passbook,
                            SMS Alert, Upi, and QR Code services which are
                            designed to facilitate the use of technology for end
                            users.
                          </p>
                          <p class="contact-info"></p>
                        </div>
                      </div>
                      <div class="contact-item">
                        <div class="contact-icon">
                          <span class="icon callicons">
                            <img
                              src="./assets/img/slideshow/pulp.png"
                              width="25"
                              he=""
                              alt=""
                            />
                          </span>
                        </div>
                        <div class="contact-details">
                          <p class="contact-info">
                            Check Here to know how Kovai Tech Nidhi Company is
                            Giving{" "}
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://www.kovaitechnidhi.com/fixed-deposit/"
                              class="brandcolor"
                            >
                              <b>High Rates Of Interest On Deposits</b>
                            </a>{" "}
                          </p>
                        </div>
                      </div>
                      <div class="contact-item">
                        <div class="contact-icon">
                          <span class="icon callicons">
                            <img
                              src="./assets/img/slideshow/pulp.png"
                              width="25"
                              he=""
                              alt=""
                            />
                          </span>
                        </div>
                        <div class="contact-details">
                          <p class="contact-info">
                            Check Nidhi Rules 2014 –{" "}
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://pib.gov.in/PressReleasePage.aspx?PRID=1818298"
                              class="brandcolor"
                            >
                              <b>Ratio of Net Owned Funds to Deposits</b>
                            </a>
                            .
                          </p>
                          <p class="contact-info">
                            –
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://pib.gov.in/PressReleasePage.aspx?PRID=1818298"
                              class="brandcolor"
                            >
                              <b>Ratio of Net Owned Funds to Deposits</b>
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 col-md-12 col-12">
                  <div class="product-details Rd_calculator ps-lg-4">
                    <h2 class="product-title mt-3 mb-3">ADDITIONAL ENQUIRY</h2>
                    <form
                      autoComplete="off"
                      className="product-form"
                      onSubmit={handleSubmit}
                    >
                      <div className="buy-it-now-btn ">
                        <fieldset>
                          <input
                            type="text"
                            className="mt-0"
                            placeholder="Customer Name"
                            name="customername"
                            value={enduiryformData.customername}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace"
                              ) {
                                e.preventDefault(); // Prevent numbers and special characters
                              }
                            }}
                          />
                          {errors.customername && (
                            <p style={{ color: "red" }}>
                              {errors.customername}
                            </p>
                          )}
                        </fieldset>
                        <fieldset>
                          <input
                            type="email"
                            className="mt-2"
                            placeholder="Email"
                            name="email"
                            value={enduiryformData.email}
                            onChange={handleChange}
                          />
                          {errors.email && (
                            <p style={{ color: "red" }}>{errors.email}</p>
                          )}
                        </fieldset>
                        <fieldset>
                          <input
                            type="text"
                            className="mt-2"
                            placeholder="Contact"
                            name="contact"
                            value={enduiryformData.contact}
                            onChange={(e) => {
                              const value = e.target.value;

                              if (/^\d{0,10}$/.test(value)) {
                                handleChange(e);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (
                                !/^\d$/.test(e.key) && // Allow only numbers
                                ![
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                ].includes(e.key) && // Allow essential keys
                                !(
                                  e.ctrlKey &&
                                  ["a", "c", "v", "x"].includes(
                                    e.key.toLowerCase()
                                  )
                                ) // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {errors.contact && (
                            <p style={{ color: "red" }}>{errors.contact}</p>
                          )}
                        </fieldset>
                        <fieldset>
                          <input
                            type="text"
                            className="mt-2"
                            placeholder="Rs.0000000"
                            name="amount"
                            value={enduiryformData.amount}
                            onChange={(e) => {
                              let numericValue = e.target.value.replace(
                                /\D/g,
                                ""
                              ); // Remove non-numeric characters

                              if (numericValue.length > 8) {
                                numericValue = numericValue.slice(0, 8); // Limit to 8 digits
                              }

                              setEnquiryFormData((prevData) => ({
                                ...prevData,
                                amount: numericValue,
                              }));
                            }}
                          />
                          {errors.amount && (
                            <p style={{ color: "red" }}>{errors.amount}</p>
                          )}
                        </fieldset>

                        <button
                          type="submit"
                          className="mt-3 position-relative btn-buyit-now"
                        >
                          Submit
                        </button>
                        {showAlert && (
                          <div
                            style={{
                              position: "absolute",

                              transition: "top 0.5s ease",
                              padding: "15px",
                              marginTop: "15px",
                              backgroundColor: "blue",
                              color: "white",
                              borderRadius: "5px",
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                              zIndex: 1000,
                            }}
                          >
                            🎉 <strong>Success!</strong> Form submitted
                            successfully.
                          </div>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        {/* <!-- footer start --> */}
        <footer class="mt-100 overflow-hidden footer-style-2">
          <div class="footer-bottom bg-5">
            <div class="container">
              <div class="footer-bottom-inner d-flex flex-wrap justify-content-md-between justify-content-center align-items-center">
                <ul class="footer-bottom-menu list-unstyled d-flex flex-wrap align-items-center mb-0">
                  <li class="footer-menu-item">
                    <a
                      href="https://www.kovaitechnidhi.com/privacy-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy policy
                    </a>
                  </li>
                  <li class="footer-menu-item">
                    <a
                      href="https://www.kovaitechnidhi.com/terms/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
                <p class="copyright footer-text">
                  ©<span class="current-year"></span> Kovai Tech Nidhi Limited
                </p>
              </div>
            </div>
          </div>
        </footer>
        {/* <!-- footer end --> */}

        {/* <!-- scrollup start --> */}
        <button id="scrollup">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
        </button>
        {/* <!-- scrollup end --> */}
      </div>
    </div>
  );
}

export default KTNL_LP;
